import type { RelatedData } from '@empathybroker/tsclient-stats/dist/models/related/related-data'
import type { RelatedResponse } from '@empathybroker/tsclient-stats/dist/models/related/related-response'
import type { ActionContext } from 'vuex'

import type { ActionClass, AnalyticsState, Pagination } from '../../../models'

import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum'

import { RelatedTypeEnum } from '../../../enums'

import { ANALYTICS_CONSTS } from '../analytics.consts'

export class LoadRelatedDataAction implements ActionClass {
  static async execute(
    this: void,
    { dispatch, commit, state }: ActionContext<AnalyticsState, any>,
    payload: { selectedId: string; type: RelatedTypeEnum; pagination: Pagination },
  ): Promise<RelatedResponse> {
    const selectedIdData = state.data.ids[payload.selectedId]
    let relatedData
    if (selectedIdData) {
      relatedData = selectedIdData.related[payload.type]
    }
    const offset = (payload.pagination.page - 1) * payload.pagination.itemsPerPage
    if (
      !relatedData ||
      relatedData.params.rows !== payload.pagination.itemsPerPage ||
      relatedData.params.offset !== offset
    ) {
      const reportId = {
        [RelatedTypeEnum.CLICK]: StatsReportsIdsEnum.RELATED_CLICK,
        [RelatedTypeEnum.ADD2CART]: StatsReportsIdsEnum.RELATED_ADD2CART,
        [RelatedTypeEnum.CHECKOUT]: StatsReportsIdsEnum.RELATED_CHECKOUT,
      }[payload.type]
      const paginationReportId = {
        [RelatedTypeEnum.CLICK]: StatsReportsIdsEnum.RELATED_CLICK_PAGINATION,
        [RelatedTypeEnum.ADD2CART]: StatsReportsIdsEnum.RELATED_ADD2CART_PAGINATION,
        [RelatedTypeEnum.CHECKOUT]: StatsReportsIdsEnum.RELATED_CHECKOUT_PAGINATION,
      }[payload.type]
      try {
        const relatedPaginationData = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
          id: paginationReportId,
          params: {
            query: payload.selectedId,
          },
        })
        relatedData = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
          id: reportId,
          params: {
            query: payload.selectedId,
            rows: payload.pagination.itemsPerPage,
            offset,
          },
        })
        relatedData.data.total = relatedPaginationData.data.productCount
        ;(relatedData.data as RelatedData).data.forEach((item: any) => {
          try {
            item.title = decodeURIComponent(item.title)
          } catch (e) {}
          item.relatedPct = Number.parseFloat(
            ((item.relatedCount / relatedPaginationData.data.relatedCount) * 100).toFixed(2),
          )
        })
        commit(ANALYTICS_CONSTS.mutations.setRelatedData, {
          data: relatedData,
          selectedId: payload.selectedId,
          relatedType: payload.type,
        })
      } catch (error) {
        throw error
      }
    }
    return relatedData
  }
}
